import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { prefixPriceWithCurrency } from '@as-react/common-utils';
import { Banner } from '@yonderland/andes-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DELAY } from '../../../constants/GeneralConstants';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { useTimeout } from '../../../hooks/useTimeout';
export const SuccessMessageBanner = ({ amount, onDismiss }) => {
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    const [isVisible, setIsVisible] = useState(true);
    const { currency } = useAemConfig();
    const handleTimeout = () => {
        setIsVisible(false);
        onDismiss();
    };
    useTimeout(handleTimeout, { delay: DELAY.DELAY_5000 });
    return isVisible ? (_jsx(Banner, { text: amount
            ? t('checkout.basket.voucher.success', { amount: prefixPriceWithCurrency(amount, currency) })
            : t('checkout.basket.voucher.success.generic'), status: "success", hasCloseBtn: false })) : null;
};
